export default __webpack_public_path__ + "static/media/George_P_Bush_0002.248330dc.jpg";